var symphony = symphony || {};

;(function() {

	symphony.getURLParam = function(name) {

		if(typeof name == 'undefined') {
			return;
		}

		//http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
		name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
		var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
		var results = regex.exec(location.search);
		
		if(!_.isArrayLike(results)) {
			return;
		}

		symphony.config.zip = decodeURIComponent(results[1].replace(/\+/g, " ")) || '22313';
		localStorage.setItem('zip', JSON.stringify(symphony.config.zip));

		if(window.localStorage && localStorage.getItem(name) !== symphony.config.zip) {
			symphony.config.updateResults = true;
			localStorage.setItem(name, symphony.config.zip);
		}

		return results === null ? "" : symphony.config.zip;

	};


})();